/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-mixed-spaces-and-tabs */
import API from "./apiHelpers";
import { routes } from "../Constants/api";
import Pusher from "pusher-js";

class PusherApptList {
    private pusher: Pusher;
    public EVENT_UPDATE: string

    constructor() {
    	this.EVENT_UPDATE = "appointment-update";
    	const cluster = process.env.REACT_APP_PUSHER_CLUSTER;
    	const pusherKey = process.env.REACT_APP_PUSHER_KEY;
    	const authEndpoint = `${API.url}${routes.pusher}`;
    	this.pusher = new Pusher(pusherKey, {cluster, authEndpoint});
    }

    public subscribeChannel = userId => {
    	return this.pusher.subscribe(`private-appointment-${userId}`);
    }

	public unsubscribeChannel = userId => {
    	return this.pusher.unsubscribe(`private-appointment-${userId}`);
	}
}

export default new PusherApptList();
